import axiosInstance from './axiosCreator';
import axios from 'axios';

export interface PresignedUrlRequest {
  filename: string;
  contentType?: string;
  fileSize?: number;
}

export interface AnkiImportSuccessfulMapping {
  ankiCardId: number;
  originalCardHtml: string;
  originalDueDate: string | null;
  mappedFlashcardId: string;
  mappedCardBackHtml: string;
  mappedDueDate: string | null;
  selectedDueSource: 'ANKI' | 'ORA' | null;
}

export interface AnkiImportHistoryJob {
  id: string;
  status: string;
  createdAt: string;
  startedAt?: string | null;
  completedAt?: string | null;
  totalCards?: number;
  cardsWithScheduling?: number;
  cardsMapped?: number;
  cardsScheduled?: number;
  cardsSkipped?: number;
  cardsDuplicates?: number;
  cardsErrored?: number;
  cardsDeferred?: number;
  s3Key?: string | null;
  successfulMappings?: AnkiImportSuccessfulMapping[] | null;
}

interface AnkiImportHistoryResponse {
  success: boolean;
  data: AnkiImportHistoryJob[];
}

export const getAnkiPresignedUrl = async (payload: PresignedUrlRequest) => {
  const response = await axiosInstance.post(
    '/api/v5/anki/import/presigned-url',
    payload
  );

  return response.data;
};

export const startAnkiImport = async (payload: {
  s3Key: string;
  importMode?: 'withScheduling' | 'withoutScheduling';
}) => {
  const response = await axiosInstance.post('/api/v5/anki/import', payload);
  return response.data;
};

export const uploadApkgToS3 = async (
  uploadUrl: string,
  file: File,
  onProgress?: (percent: number) => void
) => {
  await axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    onUploadProgress: (event) => {
      if (!event.total) return;
      const percent = Math.round((event.loaded / event.total) * 100);
      onProgress?.(percent);
    },
  });
};

export const getAnkiImportStatus = async () => {
  const response = await axiosInstance.get('/api/v5/anki/import/status');
  return response.data;
};

export const getAnkiImportHistory = async (limit = 10) => {
  const response = await axiosInstance.get('/api/v5/anki/import/history', {
    params: { limit },
  });

  return response.data as AnkiImportHistoryResponse;
};
